import { PDFsModel } from '../models/PDFsModel'
import { computed, ComputedRef, ref } from 'vue'
import { useQueue } from './useQueue'

export type UseQueuePDFsReturn = {
  isFetching: ComputedRef<boolean>
  isDeleting: ComputedRef<boolean>
  fetchProgress: ComputedRef<number>
  fetchPDFs: <T extends { [key: string]: string }>(data: T[], path: keyof T) => void
  deletePDFs: <T extends { [key: string]: string }>(data: T[], path: keyof T) => void
  cancelFetch: () => void
}
export const useQueuePDFs = (): UseQueuePDFsReturn => {
  const fetching = ref(false)
  const deleting = ref(false)
  const isFetching = computed(() => {
    return fetching.value
  })
  const isDeleting = computed(() => {
    return deleting.value
  })
  const progress = ref(0)
  const fetchProgress = computed(() => {
    return progress.value
  })
  const { addToQueue, queueSuccess, queueError, cancelQueue } = useQueue({ networkRequired: true })
  const { downloadPDF, writePDF, removePDFs } = PDFsModel()
  const fetchPDFs = async <T extends { [key: string]: string }>(data: T[], path: keyof T) => {
    progress.value = 0
    fetching.value = true
    for (const item of data) {
      if (!item[path]) {
        progress.value++
        if (progress.value >= data.length - 1) fetching.value = false
        queueSuccess() //just skip it
      }
      const getPDF = async () => {
        await downloadPDF({
          filePath: item[path],
          url: item[path],
          // url: `example-doc-server/pdfs/${item.instructions_file}`,
        })
          .then(() => {
            progress.value++
            if (progress.value >= data.length - 1) fetching.value = false
            writePDF({
              filePath: item[path],
              url: item[path],
              // url: `example-doc-server/pdfs/${item.instructions_file}`,
            }).catch((error) => console.log(error))
          })
          .catch((error) => {
            console.log(`Error grabbing pdf from list: ${error}`)
          })
      }
      await addToQueue([], getPDF)
        .then(() => {
          queueSuccess()
        })
        .catch(() => {
          queueError()
        })
    }
  }

  const deletePDFs = async <T extends { [key: string]: string }>(data: T[], path: keyof T) => {
    progress.value = 0
    deleting.value = true
    if (data && data.length) {
      for (const item of data) {
        const deletePDF = async () => {
          if (!item[path]) {
            progress.value++
            if (progress.value >= data.length - 1) fetching.value = false
            queueSuccess() //just skip it
          }
          await removePDFs([item[path]])
            .then(() => {
              progress.value++
              if (progress.value >= data.length - 1) deleting.value = false
            })
            .catch((error) => {
              console.log(`Error deleting pdf from list: ${error}`)
            })
        }
        await addToQueue([], deletePDF)
          .then(() => {
            queueSuccess()
          })
          .catch(() => {
            queueError()
          })
      }
    }
  }

  const cancelFetch = () => {
    void cancelQueue()
    fetching.value = false
    progress.value = 0
  }
  return {
    isFetching,
    isDeleting,
    fetchProgress,
    fetchPDFs,
    deletePDFs,
    cancelFetch,
  }
}
